import React, { useState, useEffect } from "react";
import { Button, Layout, Checkbox, Spin, Modal, message } from "antd";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import Cookies from "js-cookie";
import axios from "axios";
import { Redirect, Link } from "react-router-dom";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import './PayrollChecklist.css';
const { Header, Content } = Layout;

const PayrollChecklist = () => {
    // const [activitiesList, setActivitiesList] = useState(['FLSA', 'Term Date', 'Adjustments', 'Consolidation', 'Hours Audit', 'Preview/Review'])
    const [activitiesList, setActivitiesList] = useState([])
    const [sampleChecks, setSampleChecks] = useState([])
    const jwtToken = Cookies.get("jwt_token");
    const userLogin = Cookies.get("UserLogin");
    const role = Cookies.get("Role");
    const [selectedChecks, setSelectedChecks] = useState([])
    const [checksId, setChecksId] = useState([])
    const [activityLoader, setActivityLoader] = useState(false);
    const [contiueLoading, setContinueLoading] = useState(false)
    const [disabledOptions, setDisabledOptions] = useState([]);
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false)
    const [errorMsg, setErrorMsg] = useState(false)
    const [messageApi, contextHolder] = message.useMessage();
    let abc = 0
    useEffect(() => {
        if (abc === 0) {
            abc = 1
            getActivities()
        }
    }, [])
    const getActivities = async () => {
        try {
            setActivityLoader(true)
            setErrorMsg(false)
            selectedChecks.length = 0
            setSelectedChecks([])
            const resp = await axios.get(`${process.env.REACT_APP_BASE_URL}PayrollMasterAudit/getActivities`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    }
                }
            )
            const tempLT = resp.data;
            const strlength = tempLT.length;
            const loopedList = []
            for( let i = 0; i < strlength; i++){
                const email = tempLT[i].login_mail.split('@')[0].replace('.'," ").replace(/[0-9]/g, "")
                const words = email.split(' ');
                const formattedEmail = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
                loopedList.push({
                    "activity_id": tempLT[i].activity_id,
                    "activity_name": tempLT[i].activity_name,
                    "login_mail" : formattedEmail,
                    "paydate" : tempLT[i].paydate,
                    "payrolldate" : tempLT[i].payrolldate
                })
            }
            setActivitiesList([...loopedList]);
            let len = tempLT.length;
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}PayrollMasterAudit/getActivitiesCheckslist`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    }
                }
            )
            const tempList = response.data;
            let length = tempList.length
            sampleChecks.length = 0
            setSampleChecks([])
            checksId.length = 0
            setChecksId([])
            for (let i = 0; i < length; i++) {
                for (let j = 0; j < len; j++) {
                    if (tempList[i].activity_id === tempLT[j].activity_id) {
                        sampleChecks.push(j)
                        setSampleChecks([...sampleChecks])
                        checksId.push(tempList[i].activity_id)
                        setChecksId([...checksId])
                        break;
                    }
                }
            }
            setDisabledOptions(sampleChecks)
            setActivityLoader(false)
        }
        catch (error) {
            setActivityLoader(false)
            return error;
        }
    }
    const callConfirmationModal = () => {
        if (selectedChecks.length === 0) {
            setErrorMsg(true)
        }
        else {
            setOpenConfirmationModal(true)
        }
    }
    const callInsertAPi = async () => {
        try {
            setContinueLoading(true)
            let len = selectedChecks.length;
            const tempList = [];
            for (let i = 0; i < len; i++) {
                tempList.push({
                    "activity_id": activitiesList[selectedChecks[i]].activity_id,
                    "activity_name": activitiesList[selectedChecks[i]].activity_name,
                    "login_mail": userLogin,
                })
            }
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}PayrollMasterAudit/insertactivity`, tempList,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    }
                })
            if (response.status === 200) {
                for (let i = 0; i < len; i++) {
                    disabledOptions.push(selectedChecks[i])
                    setDisabledOptions([...disabledOptions])
                }
            }
            selectedChecks.length = 0
            setSelectedChecks([])
            setContinueLoading(false)
            setOpenConfirmationModal(false)
            success();
        }
        catch (error) {
            setContinueLoading(false)
            setOpenConfirmationModal(false)
            failure();
            return error
        }
    }
    const success = () => {
        messageApi.open({
            type: 'success',
            content: 'Saved successfully!!',
        });
    };
    const failure = () => {
        messageApi.open({
            type: 'error',
            content: 'Cannot able to save',
        });
    };
    const changeRadioValue = (e) => {
        setErrorMsg(false)
        let index = []
        index = e
        if (selectedChecks.includes(index)) {
            setSelectedChecks(selectedChecks.filter((item) => item !== index))
            setSampleChecks(sampleChecks.filter((item) => item !== index))
        }
        else {
            setSelectedChecks([...selectedChecks, index])
            setSampleChecks([...sampleChecks, index])
        }
    }
    if (jwtToken === undefined) {
        return <Redirect to="/" />;
    }

    return (<>
        <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
            <SideNavBar />
            <Layout style={{ backgroundColor: "white" }}>
                <Header className="masteraudit-header-class"><Navbar /></Header>
                <Content className="masteraudit-content">
                    <div className="masteraudit-allpages-class">
                        {contextHolder}
                        <Link to="/payrollhoursaudit"><Button className="masteraudit-page-button">Payroll Hours Audit</Button></Link>
                        <Link to="/preview"> <Button className="masteraudit-page-button">Preview/Review</Button></Link>
                        <Button className="masteraudit-currentpage-button">Payroll Checklist</Button>
                        <Link to="/audit"><Button className="masteraudit-page-button">Selected Crawling</Button></Link>
                        {/* <Link to="/activitylog"><Button className="masteraudit-page-button">Activity Log</Button></Link> */}
                    </div>
                    <div className="masteraudit-class">
                        <div className="audit-table">
                            {activityLoader ? <div className="issues-class-loader"> <Spin size="large" /> </div> :
                                <div className="issues-class">
                                    <Checkbox.Group value={sampleChecks} className="radio-group">
                                        <div className="radio-group-class">{
                                            activitiesList ? activitiesList.map((item, index) => {
                                                return (
                                                    <div className="radio-options-class">
                                                        <Checkbox value={index} key={item.activity_id} disabled={disabledOptions.includes(index)}
                                                            onChange={() => changeRadioValue(index, item.activity_id)} className="checkbox-class">
                                                            <p className="issue-para">{item.activity_id}. {item.activity_name}
                                                            {checksId.includes(item.activity_id) ? <span style={{color:"rgba(0, 39, 102, 1)"}}> &nbsp; &nbsp;({item.login_mail})</span> : null}
                                                            </p></Checkbox>
                                                    </div>
                                                )
                                            }) : null
                                        }
                                        </div>
                                    </Checkbox.Group>
                                </div>}
                            <div className="issue-button-class">
                                <div className="issue-buttons">
                                    <Button className="raise-continue-button" onClick={callConfirmationModal} >Update Status</Button>
                                    <Modal
                                        open={openConfirmationModal}
                                        footer={false}
                                        onOk={() => setOpenConfirmationModal(false)}
                                        onCancel={() => setOpenConfirmationModal(false)}
                                        style={{ maxHeight:'500px'}}
                                    >
                                        {role === "Super User" ? <div>
                                            <div className="icon-text-class">
                                                <div><ExclamationCircleOutlined style={{ fontSize: 20, color: "rgba(0, 39, 102, 1)" }} /></div>
                                                <div style={{ fontWeight: 400, fontSize: 16, marginTop:-6, color: "rgba(0, 39, 102, 1)" }}>Are you sure want to save?</div>
                                            </div>
                                            <div className="modal-buttons-class">
                                                <div className="modal-buttons">
                                                    <Button className="checks-cancel-button" onClick={() => setOpenConfirmationModal(false)}>Cancel</Button>
                                                    <Button className="checks-yes-button" onClick={callInsertAPi} loading={contiueLoading}>Yes</Button>
                                                </div>
                                            </div> </div> : <div className="user-icon-text-class">
                                            <div><ExclamationCircleOutlined style={{ fontSize: 20, color: "rgba(0, 39, 102, 1)" }} /></div>
                                            <div style={{ fontWeight: 400, fontSize: 17, marginTop:-5, color: "rgba(0, 39, 102, 1)", marginLeft: 20 }}>Sorry, you are not allowed to perform this action</div>
                                        </div>}
                                    </Modal>
                                </div>
                            </div>
                            <div className="continue-error-class">
                                {errorMsg && <div className="show-error" style={{ color: "#FF0000" }}>*Please select atleast one value</div>}
                            </div>
                        </div>
                    </div>
                </Content>
            </Layout >
        </Layout >
    </>)

}
export default PayrollChecklist;